// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.epw-about-page {
  --epw-red: var(--primary);
  --epw-red-dark: var(--primary-hover);
  --epw-ink: var(--text-primary);
  --epw-muted: var(--text-secondary);
  --epw-line: var(--border);
  --epw-soft: var(--hover);
  --epw-white: var(--card-bg);
  --epw-max-width: 1120px;
  --epw-radius: 16px;
  --epw-band-bg: var(--text-primary);
  --epw-shadow: 0 8px 28px var(--shadow);
}


    .epw-about-page, .epw-about-page * { box-sizing: border-box; }

    .epw-about-page {
      font-family: Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
      color: var(--epw-ink);
      background: var(--epw-white);
      line-height: 1.6;
    }

    .epw-about-page { width: 100%; }

    .epw-about-hero {
      background: linear-gradient(135deg, rgba(200,16,46,.97), rgba(125,10,31,.97));
      color: var(--epw-white);
      padding: 82px 24px 76px;
    }

    .epw-wrap {
      width: min(100%, var(--epw-max-width));
      margin: 0 auto;
    }

    .epw-eyebrow {
      margin: 0 0 12px;
      font-size: .8rem;
      font-weight: 800;
      letter-spacing: .12em;
      text-transform: uppercase;
      opacity: .9;
    }

    .epw-about-hero h1 {
      max-width: 800px;
      margin: 0;
      font-size: clamp(2.4rem, 5vw, 4.5rem);
      line-height: 1.05;
      letter-spacing: -.04em;
    }

    .epw-about-hero p {
      max-width: 820px;
      margin: 24px 0 0;
      font-size: clamp(1.08rem, 2vw, 1.28rem);
      color: rgba(255,255,255,.94);
    }

    .epw-about-main {
      padding: 62px 24px 76px;
    }

    .epw-intro {
      display: grid;
      grid-template-columns: .85fr 1.15fr;
      gap: 52px;
      align-items: start;
      margin-bottom: 56px;
    }

    .epw-section-label {
      margin: 0 0 10px;
      color: var(--epw-red);
      font-size: .8rem;
      font-weight: 800;
      letter-spacing: .11em;
      text-transform: uppercase;
    }

    .epw-intro h2,
    .epw-section-head h2 {
      margin: 0;
      font-size: clamp(1.8rem, 3vw, 2.6rem);
      line-height: 1.15;
      letter-spacing: -.03em;
    }

    .epw-intro-copy p {
      margin: 0 0 18px;
      color: var(--epw-muted);
      font-size: 1.05rem;
    }

    .epw-pillars {
      margin: 58px 0;
    }

    .epw-section-head {
      max-width: 760px;
      margin-bottom: 26px;
    }

    .epw-section-head p {
      margin: 13px 0 0;
      color: var(--epw-muted);
      font-size: 1.03rem;
    }

    .epw-pillar-grid {
      display: grid;
      grid-template-columns: repeat(4, minmax(0,1fr));
      gap: 16px;
    }

    .epw-card {
      border: 1px solid var(--epw-line);
      border-radius: var(--epw-radius);
      padding: 22px;
      background: var(--epw-white);
      box-shadow: var(--epw-shadow);
    }

    .epw-card-number {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 34px;
      height: 34px;
      margin-bottom: 16px;
      border-radius: 50%;
      background: rgba(200,16,46,.09);
      color: var(--epw-red);
      font-weight: 800;
      font-size: .88rem;
    }

    .epw-card h3 {
      margin: 0 0 8px;
      font-size: 1.04rem;
    }

    .epw-card p {
      margin: 0;
      color: var(--epw-muted);
      font-size: .94rem;
    }

    .epw-insights {
      margin-top: 60px;
      padding: 34px;
      border-radius: 20px;
      background: var(--epw-soft);
      display: grid;
      grid-template-columns: minmax(0,1fr) auto;
      gap: 32px;
      align-items: center;
    }

    .epw-insights h2 {
      margin: 0 0 10px;
      font-size: clamp(1.6rem, 3vw, 2.25rem);
      letter-spacing: -.025em;
    }

    .epw-insights p {
      margin: 0;
      max-width: 740px;
      color: var(--epw-muted);
    }

    .epw-cta {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      min-height: 48px;
      padding: 0 18px;
      border-radius: 10px;
      background: var(--epw-red);
      color: var(--epw-white);
      text-decoration: none;
      font-weight: 800;
      white-space: nowrap;
    }

    .epw-cta:hover,
    .epw-cta:focus-visible {
      background: var(--epw-red-dark);
      outline: none;
    }

    .epw-closing {
      margin-top: 58px;
      text-align: center;
      padding: 0 24px;
    }

    .epw-closing strong {
      display: block;
      font-size: clamp(1.35rem, 2.5vw, 2rem);
      letter-spacing: -.02em;
    }

    .epw-closing p {
      margin: 9px auto 0;
      max-width: 680px;
      color: var(--epw-muted);
    }

    @media (max-width: 900px) {
      .epw-intro { grid-template-columns: 1fr; gap: 22px; }
      .epw-pillar-grid { grid-template-columns: repeat(2, minmax(0,1fr)); }
      .epw-insights { grid-template-columns: 1fr; }
    }

    @media (max-width: 620px) {
      .epw-about-hero { padding: 58px 20px 54px; }
      .epw-about-main { padding: 42px 18px 58px; }
      .epw-pillar-grid { grid-template-columns: 1fr; }
      .epw-insights { padding: 24px; }
      .epw-cta { width: 100%; }
    }
  `, "",{"version":3,"sources":["webpack://./src/pages/AboutPage.css"],"names":[],"mappings":";AACA;EACE,yBAAyB;EACzB,oCAAoC;EACpC,8BAA8B;EAC9B,kCAAkC;EAClC,yBAAyB;EACzB,wBAAwB;EACxB,2BAA2B;EAC3B,uBAAuB;EACvB,kBAAkB;EAClB,kCAAkC;EAClC,sCAAsC;AACxC;;;IAGI,qCAAqC,sBAAsB,EAAE;;IAE7D;MACE,uGAAuG;MACvG,qBAAqB;MACrB,4BAA4B;MAC5B,gBAAgB;IAClB;;IAEA,kBAAkB,WAAW,EAAE;;IAE/B;MACE,6EAA6E;MAC7E,uBAAuB;MACvB,uBAAuB;IACzB;;IAEA;MACE,sCAAsC;MACtC,cAAc;IAChB;;IAEA;MACE,gBAAgB;MAChB,gBAAgB;MAChB,gBAAgB;MAChB,qBAAqB;MACrB,yBAAyB;MACzB,WAAW;IACb;;IAEA;MACE,gBAAgB;MAChB,SAAS;MACT,qCAAqC;MACrC,iBAAiB;MACjB,sBAAsB;IACxB;;IAEA;MACE,gBAAgB;MAChB,gBAAgB;MAChB,uCAAuC;MACvC,4BAA4B;IAC9B;;IAEA;MACE,uBAAuB;IACzB;;IAEA;MACE,aAAa;MACb,mCAAmC;MACnC,SAAS;MACT,kBAAkB;MAClB,mBAAmB;IACrB;;IAEA;MACE,gBAAgB;MAChB,qBAAqB;MACrB,gBAAgB;MAChB,gBAAgB;MAChB,qBAAqB;MACrB,yBAAyB;IAC3B;;IAEA;;MAEE,SAAS;MACT,qCAAqC;MACrC,iBAAiB;MACjB,sBAAsB;IACxB;;IAEA;MACE,gBAAgB;MAChB,uBAAuB;MACvB,kBAAkB;IACpB;;IAEA;MACE,cAAc;IAChB;;IAEA;MACE,gBAAgB;MAChB,mBAAmB;IACrB;;IAEA;MACE,gBAAgB;MAChB,uBAAuB;MACvB,kBAAkB;IACpB;;IAEA;MACE,aAAa;MACb,+CAA+C;MAC/C,SAAS;IACX;;IAEA;MACE,iCAAiC;MACjC,gCAAgC;MAChC,aAAa;MACb,4BAA4B;MAC5B,6BAA6B;IAC/B;;IAEA;MACE,oBAAoB;MACpB,mBAAmB;MACnB,uBAAuB;MACvB,WAAW;MACX,YAAY;MACZ,mBAAmB;MACnB,kBAAkB;MAClB,+BAA+B;MAC/B,qBAAqB;MACrB,gBAAgB;MAChB,iBAAiB;IACnB;;IAEA;MACE,eAAe;MACf,kBAAkB;IACpB;;IAEA;MACE,SAAS;MACT,uBAAuB;MACvB,iBAAiB;IACnB;;IAEA;MACE,gBAAgB;MAChB,aAAa;MACb,mBAAmB;MACnB,2BAA2B;MAC3B,aAAa;MACb,yCAAyC;MACzC,SAAS;MACT,mBAAmB;IACrB;;IAEA;MACE,gBAAgB;MAChB,sCAAsC;MACtC,uBAAuB;IACzB;;IAEA;MACE,SAAS;MACT,gBAAgB;MAChB,uBAAuB;IACzB;;IAEA;MACE,oBAAoB;MACpB,mBAAmB;MACnB,uBAAuB;MACvB,gBAAgB;MAChB,eAAe;MACf,mBAAmB;MACnB,0BAA0B;MAC1B,uBAAuB;MACvB,qBAAqB;MACrB,gBAAgB;MAChB,mBAAmB;IACrB;;IAEA;;MAEE,+BAA+B;MAC/B,aAAa;IACf;;IAEA;MACE,gBAAgB;MAChB,kBAAkB;MAClB,eAAe;IACjB;;IAEA;MACE,cAAc;MACd,sCAAsC;MACtC,sBAAsB;IACxB;;IAEA;MACE,kBAAkB;MAClB,gBAAgB;MAChB,uBAAuB;IACzB;;IAEA;MACE,aAAa,0BAA0B,EAAE,SAAS,EAAE;MACpD,mBAAmB,+CAA+C,EAAE;MACpE,gBAAgB,0BAA0B,EAAE;IAC9C;;IAEA;MACE,kBAAkB,uBAAuB,EAAE;MAC3C,kBAAkB,uBAAuB,EAAE;MAC3C,mBAAmB,0BAA0B,EAAE;MAC/C,gBAAgB,aAAa,EAAE;MAC/B,WAAW,WAAW,EAAE;IAC1B","sourcesContent":["\n.epw-about-page {\n  --epw-red: var(--primary);\n  --epw-red-dark: var(--primary-hover);\n  --epw-ink: var(--text-primary);\n  --epw-muted: var(--text-secondary);\n  --epw-line: var(--border);\n  --epw-soft: var(--hover);\n  --epw-white: var(--card-bg);\n  --epw-max-width: 1120px;\n  --epw-radius: 16px;\n  --epw-band-bg: var(--text-primary);\n  --epw-shadow: 0 8px 28px var(--shadow);\n}\n\n\n    .epw-about-page, .epw-about-page * { box-sizing: border-box; }\n\n    .epw-about-page {\n      font-family: Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, \"Segoe UI\", sans-serif;\n      color: var(--epw-ink);\n      background: var(--epw-white);\n      line-height: 1.6;\n    }\n\n    .epw-about-page { width: 100%; }\n\n    .epw-about-hero {\n      background: linear-gradient(135deg, rgba(200,16,46,.97), rgba(125,10,31,.97));\n      color: var(--epw-white);\n      padding: 82px 24px 76px;\n    }\n\n    .epw-wrap {\n      width: min(100%, var(--epw-max-width));\n      margin: 0 auto;\n    }\n\n    .epw-eyebrow {\n      margin: 0 0 12px;\n      font-size: .8rem;\n      font-weight: 800;\n      letter-spacing: .12em;\n      text-transform: uppercase;\n      opacity: .9;\n    }\n\n    .epw-about-hero h1 {\n      max-width: 800px;\n      margin: 0;\n      font-size: clamp(2.4rem, 5vw, 4.5rem);\n      line-height: 1.05;\n      letter-spacing: -.04em;\n    }\n\n    .epw-about-hero p {\n      max-width: 820px;\n      margin: 24px 0 0;\n      font-size: clamp(1.08rem, 2vw, 1.28rem);\n      color: rgba(255,255,255,.94);\n    }\n\n    .epw-about-main {\n      padding: 62px 24px 76px;\n    }\n\n    .epw-intro {\n      display: grid;\n      grid-template-columns: .85fr 1.15fr;\n      gap: 52px;\n      align-items: start;\n      margin-bottom: 56px;\n    }\n\n    .epw-section-label {\n      margin: 0 0 10px;\n      color: var(--epw-red);\n      font-size: .8rem;\n      font-weight: 800;\n      letter-spacing: .11em;\n      text-transform: uppercase;\n    }\n\n    .epw-intro h2,\n    .epw-section-head h2 {\n      margin: 0;\n      font-size: clamp(1.8rem, 3vw, 2.6rem);\n      line-height: 1.15;\n      letter-spacing: -.03em;\n    }\n\n    .epw-intro-copy p {\n      margin: 0 0 18px;\n      color: var(--epw-muted);\n      font-size: 1.05rem;\n    }\n\n    .epw-pillars {\n      margin: 58px 0;\n    }\n\n    .epw-section-head {\n      max-width: 760px;\n      margin-bottom: 26px;\n    }\n\n    .epw-section-head p {\n      margin: 13px 0 0;\n      color: var(--epw-muted);\n      font-size: 1.03rem;\n    }\n\n    .epw-pillar-grid {\n      display: grid;\n      grid-template-columns: repeat(4, minmax(0,1fr));\n      gap: 16px;\n    }\n\n    .epw-card {\n      border: 1px solid var(--epw-line);\n      border-radius: var(--epw-radius);\n      padding: 22px;\n      background: var(--epw-white);\n      box-shadow: var(--epw-shadow);\n    }\n\n    .epw-card-number {\n      display: inline-flex;\n      align-items: center;\n      justify-content: center;\n      width: 34px;\n      height: 34px;\n      margin-bottom: 16px;\n      border-radius: 50%;\n      background: rgba(200,16,46,.09);\n      color: var(--epw-red);\n      font-weight: 800;\n      font-size: .88rem;\n    }\n\n    .epw-card h3 {\n      margin: 0 0 8px;\n      font-size: 1.04rem;\n    }\n\n    .epw-card p {\n      margin: 0;\n      color: var(--epw-muted);\n      font-size: .94rem;\n    }\n\n    .epw-insights {\n      margin-top: 60px;\n      padding: 34px;\n      border-radius: 20px;\n      background: var(--epw-soft);\n      display: grid;\n      grid-template-columns: minmax(0,1fr) auto;\n      gap: 32px;\n      align-items: center;\n    }\n\n    .epw-insights h2 {\n      margin: 0 0 10px;\n      font-size: clamp(1.6rem, 3vw, 2.25rem);\n      letter-spacing: -.025em;\n    }\n\n    .epw-insights p {\n      margin: 0;\n      max-width: 740px;\n      color: var(--epw-muted);\n    }\n\n    .epw-cta {\n      display: inline-flex;\n      align-items: center;\n      justify-content: center;\n      min-height: 48px;\n      padding: 0 18px;\n      border-radius: 10px;\n      background: var(--epw-red);\n      color: var(--epw-white);\n      text-decoration: none;\n      font-weight: 800;\n      white-space: nowrap;\n    }\n\n    .epw-cta:hover,\n    .epw-cta:focus-visible {\n      background: var(--epw-red-dark);\n      outline: none;\n    }\n\n    .epw-closing {\n      margin-top: 58px;\n      text-align: center;\n      padding: 0 24px;\n    }\n\n    .epw-closing strong {\n      display: block;\n      font-size: clamp(1.35rem, 2.5vw, 2rem);\n      letter-spacing: -.02em;\n    }\n\n    .epw-closing p {\n      margin: 9px auto 0;\n      max-width: 680px;\n      color: var(--epw-muted);\n    }\n\n    @media (max-width: 900px) {\n      .epw-intro { grid-template-columns: 1fr; gap: 22px; }\n      .epw-pillar-grid { grid-template-columns: repeat(2, minmax(0,1fr)); }\n      .epw-insights { grid-template-columns: 1fr; }\n    }\n\n    @media (max-width: 620px) {\n      .epw-about-hero { padding: 58px 20px 54px; }\n      .epw-about-main { padding: 42px 18px 58px; }\n      .epw-pillar-grid { grid-template-columns: 1fr; }\n      .epw-insights { padding: 24px; }\n      .epw-cta { width: 100%; }\n    }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
